import { Observable } from 'rxjs';

export const VIEWPORT_ELEMENT_FALLBACK_CHECK_INTERVAL = 500;

export const isElementInViewport = function (
  element: HTMLElement,
  offset: number
) {
  const rect = element.getBoundingClientRect();
  const viewportHeight =
    window.innerHeight || document.documentElement.clientHeight;
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth;
  const viewportTop = window.scrollY;
  const viewportLeft = window.scrollX;
  return (
    rect.top >= viewportTop - offset &&
    rect.top + rect.height <= viewportTop + viewportHeight + offset &&
    rect.left >= viewportLeft - offset &&
    rect.left + rect.width <= viewportLeft + viewportWidth + offset
  );
};

export const viewportVisibilityChange = function (
  element: HTMLElement,
  offset: number
): Observable<boolean> {
  return new Observable((subscriber) => {
    let isVisible = null;
    if (window.IntersectionObserver) {
      const observer = new window.IntersectionObserver(
        (entries) => {
          const anyEntryIsIntersecting = entries.reduce((active, entry) => {
            return active || entry.isIntersecting;
          }, false);
          if (isVisible !== anyEntryIsIntersecting) {
            subscriber.next(anyEntryIsIntersecting);
            isVisible = anyEntryIsIntersecting;
          }
        },
        { rootMargin: offset + 'px' }
      );
      observer.observe(element);
      return () => {
        observer.disconnect();
      };
    }

    const checkInterval = setInterval(() => {
      const check = isElementInViewport(element, offset);
      if (isVisible !== check) {
        subscriber.next(check);
        isVisible = check;
      }
    }, VIEWPORT_ELEMENT_FALLBACK_CHECK_INTERVAL);

    return () => {
      clearInterval(checkInterval);
    };
  });
};
